import { useEffect, useState } from "react";
import { _Inbox, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { _CostStudy, _Exportations, _ImportContracts, _ImportCostSettlement, _ImportDeclaration, _SupplierPaymentOrder, _SupplierPaymentOrderItem } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { MakeUBLInvoice } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/MakeUBLInvoice";
import { ThirdBankingAccountEditor } from "../../../../../Talentohumano/ParametrosTalentoHumano/ThirdBankingAccount/ThirdBanking.editor";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { SelectAdquisitionContract } from "../../../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { InputMoney } from "../../../../../theme/Input/InputMoney";


interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

export const CONT001 = ({ configProcedure }: Props) => {

    const ImportContracts = useDataBean(_ImportContracts);
    const [invoice, setInvoice] = useState<any>({});
    const [props, setProps] = useState<any>({});
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalConfAdd, setModalConfAdd] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    useEffect(() => {
        if (configProcedure?._pocessData?.Props) {
            setProps(configProcedure?._pocessData?.Props)
        }
    }, [configProcedure?._pocessData])

    const onExportMap = () => {
        if (configProcedure?._pushInfo) {
            configProcedure?._pushInfo(ImportContracts.bean.Observations)
        }

        if (configProcedure?._pushProps) {
            let x = {

                ContractNumber: ImportContracts.bean.ContractNumber,
                ContractTotalValue: ImportContracts.bean.ContractTotalValue,
                TransportDocument: ImportContracts.bean.TransportDocument,
                NumberOfElements: ImportContracts.bean.NumberOfElements,
                DAPUSDValue: ImportContracts.bean.DAPUSDValue,
                DAPCOPValue: ImportContracts.bean.DAPCOPValue,
                IDAdquisitionContract: ImportContracts.bean.IDAdquisitionContract,
                DIM: ImportContracts.bean.DIM,
                ImportContractDate: ImportContracts.bean.ImportContractDate,
                CostStudyComissionValue: ImportContracts.bean.CostStudyComissionValue,
                CommissionValueSettlementCosts: ImportContracts.bean.CommissionValueSettlementCosts,
                ElementDescription: ImportContracts.bean.ElementDescription,
                ProjectedTRM: ImportContracts.bean.ProjectedTRM,
                ExecutionPeriod: ImportContracts.bean.ExecutionPeriod,
                Observations: ImportContracts.bean.Observations,
                InteradministrativeExpiration: ImportContracts.bean.InteradministrativeExpiration,
                TransferDate: ImportContracts.bean.TransferDate,
                TransferNumber: ImportContracts.bean.TransferNumber,
                DateChangeForm: ImportContracts.bean.DateChangeForm,
                PendingAmountToBeTransferred: ImportContracts.bean.PendingAmountToBeTransferred,
                ExchangeRateValueAdvancePurchase: ImportContracts.bean.ExchangeRateValueAdvancePurchase,
                AdvanceAmount: ImportContracts.bean.AdvanceAmount,
                ExchangeRateValueRemainingBalancePurchase: ImportContracts.bean.ExchangeRateValueRemainingBalancePurchase,
                ContractBalanceAmount: ImportContracts.bean.ContractBalanceAmount,
                SuggestedExchangeRate: ImportContracts.bean.SuggestedExchangeRate,

                State: 1,
                Since: _single.getCurrenDate(),
                IDEmployee: _single.getAccountID()

            }
            configProcedure?._pushProps(x)
        }

        if (configProcedure?._exportMap) {
            configProcedure?._exportMap(ImportContracts.bean)
        }
        toast.success('Actualizado')
    }


    const create = () => {
        ImportContracts.setBean({
            State: 1,
            Since: _single.getCurrenDate(),
            IDEmployee: _single.getAccountID()
        });
        editaItem()
    }

    const editaItem = () => {
        //console.log(entailment.bean);
        ImportContracts.update().then(
            (resp: any) => {
                onExportMap()
                console.log(resp)
                toast.success('Actualizado');
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    return (
        <div className="row">
            <div className="col-md-12">


                <div className="row">
                    <div className="col-md-6">
                        <label>Número de contrato</label>
                        <input type="text" name="ContractNumber" className="form-control" value={ImportContracts.bean.ContractNumber} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>ValorTotal del Contrato</label>
                        <input type="text" name="ContractTotalValue" className="form-control" value={ImportContracts.bean.ContractTotalValue} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Transporte Documento</label>
                        <input type="text" name="TransportDocument" className="form-control" value={ImportContracts.bean.TransportDocument} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de elementos</label>
                        <input type="text" name="NumberOfElements" className="form-control" value={ImportContracts.bean.NumberOfElements} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor de DAPUSD</label>
                        <input type="text" name="DAPUSDValue" className="form-control" value={ImportContracts.bean.DAPUSDValue} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor DAPCOP</label>
                        <input type="text" name="DAPCOPValue" className="form-control" value={ImportContracts.bean.DAPCOPValue} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label>
                            Contrato de Adquisición</label>
                        <SelectAdquisitionContract data={{ IDAccount: ImportContracts.bean.IDAccount }} idSelector={ImportContracts.bean.IDAdquisitionContract} onChange={({ DataBeanProperties }) => { ImportContracts.setBean({ ...ImportContracts.bean, 'IDAdquisitionContract': DataBeanProperties.IDAdquisitionContract }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>DIM</label>
                        <input type="text" name="DIM" className="form-control" value={ImportContracts.bean.DIM} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="ImportContractDate" label="Fecha de declaración de importación" value={ImportContracts.bean.ImportContractDate} setDate={(e: any) => { ImportContracts.setBean({ ...ImportContracts.bean, "ImportContractDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor de la comisión del estudio de costos</label>
                        <input type="text" name="CostStudyComissionValue" className="form-control" value={ImportContracts.bean.CostStudyComissionValue} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Costos de liquidación del valor de la comisión</label>
                        <input type="text" name="CommissionValueSettlementCosts" className="form-control" value={ImportContracts.bean.CommissionValueSettlementCosts} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label>
                            Elemento Descripción</label>
                        <textarea name="ElementDescription" className="form-control" value={ImportContracts.bean.ElementDescription} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>
                            TRM proyectado</label>
                        <input type="text" name="ProjectedTRM" className="form-control" value={ImportContracts.bean.ProjectedTRM} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>
                            Periodo de ejecución</label>
                        <input type="text" name="ExecutionPeriod" className="form-control" value={ImportContracts.bean.ExecutionPeriod} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="InteradministrativeExpiration" label="Vencimiento interadministrativo" value={ImportContracts.bean.InteradministrativeExpiration} setDate={(e: any) => { ImportContracts.setBean({ ...ImportContracts.bean, "InteradministrativeExpiration": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="TransferDate" label="Fecha de transferencia" value={ImportContracts.bean.TransferDate} setDate={(e: any) => { ImportContracts.setBean({ ...ImportContracts.bean, "TransferDate": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Número de transferencia</label>
                        <input type="text" name="TransferNumber" className="form-control" value={ImportContracts.bean.TransferNumber} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <InputDate name="DateChangeForm" label="Formulario de cambio de fecha" value={ImportContracts.bean.DateChangeForm} setDate={(e: any) => { ImportContracts.setBean({ ...ImportContracts.bean, "DateChangeForm": e }) }} />
                    </div>
                    <div className="col-md-6">
                        <label>Monto pendiente a transferir</label>
                        <input type="text" name="PendingAmountToBeTransferred" className="form-control" value={ImportContracts.bean.PendingAmountToBeTransferred} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Compra anticipada del valor del tipo de cambio</label>
                        <input type="text" name="ExchangeRateValueAdvancePurchase" className="form-control" value={ImportContracts.bean.ExchangeRateValueAdvancePurchase} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Importe adelantado</label>
                        <input type="text" name="AdvanceAmount" className="form-control" value={ImportContracts.bean.AdvanceAmount} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Valor del tipo de cambio Saldo restante Compra</label>
                        <input type="text" name="ExchangeRateValueRemainingBalancePurchase" className="form-control" value={ImportContracts.bean.ExchangeRateValueRemainingBalancePurchase} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Saldo del contrato</label>
                        <input type="text" name="ContractBalanceAmount" className="form-control" value={ImportContracts.bean.ContractBalanceAmount} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Tipo de cambio sugerido</label>
                        <input type="text" name="SuggestedExchangeRate" className="form-control" value={ImportContracts.bean.SuggestedExchangeRate} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-6">
                        <label>Periodo de ejecución</label>
                        <input type="text" name="ExecutionPeriod" className="form-control" value={ImportContracts.bean.ExecutionPeriod} onChange={ImportContracts.handleChange} />
                    </div>
                    <div className="col-md-12">
                        <label>Observaciones</label>

                        <textarea name="Observations" className="form-control" value={ImportContracts.bean.Observations} onChange={(e) => { ImportContracts.setBean({ ...ImportContracts.bean, 'Observation': e.target.value }) }} />
                    </div>

                </div>
                <div className="row">
                    <div className="col-md-6">
                        <BasicButton icon="ri-send-plane-fill" clase="primary" eventClick={create}>Guardar Datos*</BasicButton>
                    </div>
                </div>
            </div>
        </div>
    )
}